import React from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';
import {GamesGridBatchComponent} from './games-grid-batch/games-grid-batch.component';
import {GamesGridBox} from './boxes/games-grid/games-grid.box';
import {NoGamesFoundMessageBox} from './boxes/no-games-found-message/no-games-found-message.box';
import classNames from 'classnames';
import {GRID_GAMES_LIST} from '../single-game/css-constants';
import {GamesGridContainerBox} from "./boxes/games-grid-container.box";
import {IGamesListViewModel} from "../../services/arenas/models/lists/games-list-view-model.interface";

export interface GamesGridComponentProps {
  viewModel: IGamesListViewModel;
  skipIntermediatePage: boolean;
  disableGameInfoHover: boolean;
  useSquareIcons?: boolean;
}

export const GamesGridComponent = observer(class GamesGridComponent extends OrbitComponent<GamesGridComponentProps> {

  private _renderTitle() {

    if(!this.props.disableGameInfoHover && this.services.gamesFilter.isFilterOn) {
      return null;
    }
    return this.props.viewModel.renderListHeader();
  }

  private _renderGames(gameTypes: number[]) {
    return (

        <GamesGridBox className={classNames('cy-games-grid', GRID_GAMES_LIST)}>
            <GamesGridBatchComponent batchIndex={0}
                                     gameTypes={gameTypes}
                                     aiEngine={this.props.viewModel.aiEngine}
                                     templateType={this.props.viewModel.templateType}
                                     seoCategory={this.props.viewModel.arenaName}
                                     listTitleTranslationKey={this.props.viewModel.title.translationKey}
                                     skipIntermediatePage={this.props.skipIntermediatePage}
                                     useSquareIcons={this.props.useSquareIcons}
                                     disableGameInfoHover={this.props.disableGameInfoHover} />
      </GamesGridBox>
    );
  }

  private _renderNoGames() {
    if(this.services.gamesFilter.isFilterOn) {
      return (
        <NoGamesFoundMessageBox>{this.services.translation.translate('YOUR_SEARCH_DID_NOT_MATCH_ANY_GAMES')}</NoGamesFoundMessageBox>
      )
    } else {
      return null;
    }
  }

  private _renderContent() {
    let gameTypes = this.props.viewModel.gameTypes;
    if(gameTypes.length === 0) {
      return this._renderNoGames();
    }
    return (
      <>
        {this._renderTitle()}
        {this._renderGames(gameTypes)}
      </>
    );
  }


  render() {
    return (
      <GamesGridContainerBox className={'cy-games-grid-container'}>
        {this._renderContent()}
      </GamesGridContainerBox>
    );
  }
});
